/* global galleryThumbnailUrls */
$(document).ready(function ($) {
  if (!$("body").hasClass("single-studio")) {
    return;
  }
  /**
   * CODE FOR SINGLE-STUDIO & SINGLE-STUDIO-SUBPAGES GOES HERE
   **/
  $("#become-member-container").removeClass("disabled");

  /** ============================================================ **/

  if ($("body").hasClass("single-studio-subpage")) {
    /**
     * CODE FOR SINGLE-STUDIO SUBPAGES ONLY (without single-studio MAIN page) GOES HERE
     **/
    return;
  }

  /**
   * CODE FOR SINGLE-STUDIO ONLY (without single-studio-subpages) GOES HERE
   **/
  $(".studio__section-gallery--content-wrapper").slick({
    dots: true,
    lazyLoad: 'ondemand',
    // adaptiveHeight: true,
    focusOnSelect: true,
    arrows: true,
    prevArrow: '<div class="slick-arrow slick-prev"></div>',
    nextArrow: '<div class="slick-arrow slick-next"></div>',
    customPaging: function (slider, i) {
      if (galleryThumbnailUrls) {
        return '<div class="thumbnails"><img src="' + galleryThumbnailUrls[i] + '"></div>';
      }

      return '<div class="thumbnails">' + $(slider.$slides[i]).find("img").prop("outerHTML") + "</div>";
    },
  });

  // Services sliders
  $(".studio__section-services--group").slick({
    dots: true,
    // adaptiveHeight: true,
    focusOnSelect: true,
    infinite: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: true,
    prevArrow: '<div class="slick-arrow slick-prev"></div>',
    nextArrow: '<div class="slick-arrow slick-next"></div>',
  });

  // Legal withdrawal-rights info
  $(".studio__section-legal--toggle-withdrawal-rights").on("click", function (event) {
    event.preventDefault();
    $(".studio__section-legal--withdrawal-rights").toggleClass("visible");
  });
});
